export default "__VITE_ASSET__BXBIq46i__"